export default function(imageUrl, preset) {
    if (!preset)
        return imageUrl
    
    var urlWithoutQueryParams = imageUrl.split('?')[0]
    var transform = preset.transform ?? "fill"
    return urlWithoutQueryParams + `?io=transform:${transform},width:${preset.width},height:${preset.height}`
}